import { render, staticRenderFns } from "./CourseDetailView.vue?vue&type=template&id=00dd1a1b&scoped=true&"
import script from "./CourseDetailView.vue?vue&type=script&lang=js&"
export * from "./CourseDetailView.vue?vue&type=script&lang=js&"
import style0 from "./CourseDetailView.vue?vue&type=style&index=0&id=00dd1a1b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dd1a1b",
  null
  
)

export default component.exports